import React from 'react';
import polyneticaLogo from '../../assets/icons/header/logo/purpleLogo.svg';
import { hasAvatarUrl } from '../../helpers/avatar';

export const UserAvatar = ({ src, className = '' }) => {
  const hasAvatar = hasAvatarUrl(src);

  return (
    <div
      className={`flex items-center justify-center overflow-hidden rounded-full bg-[#1A1820] bg-cover bg-center bg-no-repeat ${className}`}
      style={hasAvatar ? { backgroundImage: `url(${src})` } : undefined}
    >
      {!hasAvatar ? <img src={polyneticaLogo} alt="" className="h-[62%] w-[62%] object-contain" /> : null}
    </div>
  );
};
